import React, { useState } from 'react'
import { Container, Typography, Grid2, Link, Skeleton, Paper, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers'
import { IconChevronLeft } from '@tabler/icons-react'
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom'
import DOMPurify from 'dompurify';  
import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

import CustomButton from '@components/button/customButton'

import { UserApiEndpoints } from '@configuration/apiEndpoints'

import { EVENT_STATUS_GUID } from '@utils/constant'

import { AssetUrl } from '@configuration/apiEndpoints'

import "./post.css";

export default function Post() {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()

  // console.log(id)
  const { data, isError } = useQuery({
    queryKey: ['getPost', id],
    queryFn: () =>
      axios.get(`${UserApiEndpoints.getActivityByGuid}/${id}`, { requiresAuth: false }),
    initialData: [],
    select: (res) => res?.data || null,
  })

  // console.log(data)

  const otherActivity = useQuery({
    queryKey: ['getActivity', id],
    queryFn: () =>
      axios.get(UserApiEndpoints.getActivity, { requiresAuth: false }),
    initialData: [],
    select: (res) => {
      const filteredData = (res?.data || []).filter(item => item.postGuid !== id);
  
      // Shuffle and pick 3 random items
      const shuffledData = filteredData.sort(() => 0.5 - Math.random());
      return shuffledData.slice(0, 3);
    },
  })

  const onBack = () => {
    navigate(`/activity`, { replace: true });
  }

  const sanitizedContent = DOMPurify.sanitize(data ? data?.[`content${t('param')}`] : ``, {
    ADD_TAGS: ["iframe"], // Add iframe to the list of allowed tags
    ADD_ATTR: ["src", "width", "height", "allowfullscreen", "frameborder"] // Specify allowed attributes
  });

  const isSkeleton = !(data);
  
  return (
    <Container className='activity-post'>
      <Link onClick={onBack} underline="hover" color='#414042' fontSize={'14px'} style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer'}}>
        <IconChevronLeft size={15}/>{t('activity-page.back')}
      </Link>
      <Typography className='category'>{isSkeleton ? <Skeleton animation={!isError && 'pulse'} variant='text'/> : t(`activity-page.${data?.category?.valueEng}`)}</Typography>
      <Typography className='title'>{isSkeleton ? <Skeleton animation={!isError && 'pulse'} variant='text'/> : data?.[`title${t('param')}`]}</Typography>
      <Grid2 container spacing={'25px'}>
        <Grid2 size={{ lg: 8, md: 8,  sm: 12, xs: 12 }}>
          {isSkeleton ?
          <Skeleton animation={!isError && 'pulse'} variant="rounded" height={"400px"} style={{borderRadius: '10px'}}/>
          :
          <Paper className='content-card'>
            {/* <img src={data?.thumbnailPath} style={{aspectRatio: "16 / 23", width: "100%", backgroundColor: '#E8EBEB', objectFit: 'contain'}}/> */}
            <div
              dangerouslySetInnerHTML={{ __html: sanitizedContent }}
              className="rich-text-content"
            />
            {(data?.eventStatus.parameterGuid === EVENT_STATUS_GUID.OPENED && data?.isRegister) &&
              <>
                <Typography className='description'>{t('activity-page.registerInstruction')}</Typography>
                <CustomButton component={RouterLink} to={`/activity/register/${id}`}>{t('activity-page.register')}</CustomButton>
              </>
            }
          </Paper>
          }
        </Grid2>
        <Grid2 size={{ lg: 4, md: 4,  sm: 12, xs: 12 }}>
          {otherActivity.isFetching ?
          <Skeleton animation={!otherActivity.isError && 'pulse'} variant="rounded" height={"400px"} style={{borderRadius: '10px'}}/>
          :
          <Paper className='link-card'>
            <Typography className='link-title'>{t('activity-page.otherActivity')}</Typography>
            {
              otherActivity.data &&
              otherActivity.data.length > 0 ?
              otherActivity.data.map((data, index) => (
                <Box component={RouterLink} to={`/activity/${data?.postGuid}`} className='activity-card' key={index}>
                  <img src={`${AssetUrl}${data?.thumbnailPath}`} style={{aspectRatio: "32/43", width: "52px", backgroundColor: '#E8EBEB', objectFit: 'contain'}}/>
                  <div className='text-wrapper'>
                    <Typography className='card-category'>{t(`activity-page.${data?.category?.valueEng}`)}</Typography>
                    <Typography className='card-title'>{ data?.[`title${t('param')}`] || '-'}</Typography>
                  </div>
                </Box>
              ))
              :
              <>
                <Box sx={{backgroundColor: '#F7F9F9', padding: '20px 0px'}}>
                  <Typography fontSize={'0.9rem'} color='#414042' fontWeight={500} textAlign={'center'}>{t('activity-page.noOtherActivity')}</Typography>
                </Box>
              </>
            }
          </Paper>
          }
        </Grid2>
      </Grid2>
    </Container>
  )
}
